<template>
  <div class="DropDownLinkContainer md:ml-4 lg:ml-6">
    <button>
      {{ $t(title) }}
    </button>
    <div class="LinksParent">
      <div class="hiddenLayer"></div>
      <ul class="Links">
        <slot></slot>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title'],
};
</script>

<style scoped>
.DropDownLinkContainer {
  position: relative;
}
button {
  color: white;
}
.LinksParent {
  position: absolute;
  right: -100%;
  width: min-content;
}
.Links {
  display: flex;
}
.DropDownLinkContainer:hover .Links {
  display: flex;
}
.hiddenLayer:hover .Links {
  display: flex;
}
.button:hover .Links {
  display: flex;
}
.Links {
  display: none;
  align-items: flex-start;
  flex-direction: row;
  justify-content: space-around;
  flex-direction: column;
  background: #ecf1f2;
  padding: 1em 1em 0em 1em;
  width: max-content;
  box-shadow: 0 3px 4px #00000029;
}
.Links > li {
  margin-bottom: 1em;
}
.hiddenLayer {
  height: 5px;
  width: 100%;
}
</style>
